import { Button, Flex, Text } from "@chakra-ui/react";
import { MdWarning } from "react-icons/md";
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
} from "./chakra/dialog";

interface ErrorAlertProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title: React.ReactNode | string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  isOpen,
  onClose,
  children,
  title,
}) => {
  return (
    <DialogRoot
      isOpen={isOpen}
      onClose={onClose}
      role="alertdialog"
      isCentered
      size="md"
    >
      <DialogContent>
        <DialogHeader pb={2}>
          <Flex align="center" color="red.500" gap={2}>
            <MdWarning />
            <Text fontSize="lg" fontWeight="bold">
              {title}
            </Text>
          </Flex>
        </DialogHeader>

        <DialogBody>{children}</DialogBody>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default ErrorAlert;
